import {
  CommandDialog,
  SearchIcon,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@repo/ui';
import { useMemo, useState } from 'react';
import { SearchComponent } from '.';

export function SearchDialog() {
  const [open, setOpen] = useState(false);

  const memoizedSearchIcon = useMemo(() => <SearchIcon />, []);
  const memoizedCommandDialog = useMemo(
    () => (
      <CommandDialog onOpenChange={setOpen} open={open}>
        <SearchComponent displayEmpty limit={10} />
      </CommandDialog>
    ),
    [open]
  );

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        className=" font-sidebar group-data-[collapsible=icon]:p-2!"
        data-sidebar="menu-button"
        onClick={() => {
          setOpen(true);
        }}
        variant="default"
        // size="lg"
      >
        {memoizedSearchIcon}

        <span className="">Search</span>
      </SidebarMenuButton>
      {memoizedCommandDialog}
    </SidebarMenuItem>
  );
}
